// extracted by mini-css-extract-plugin
export default {"statistics_item":"dashboardItem_statistics_item__Aqk93"};